import React from 'react'
import SvgIcon from '../SvgIcon'

export default function CalendarIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15">
      <path
        d="M12.1,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,14 C15,14.5522847 14.5522847,15 14,15 L1,15 C0.44771525,15 6.76353751e-17,14.5522847 0,14 L0,2 C6.76353751e-17,1.44771525 0.44771525,1 1,1 L2.9,1 L2.9,0.5 C2.9,0.223857625 3.12385763,-1.69088438e-17 3.4,0 L3.6,0 C3.87614237,1.69088438e-17 4.1,0.223857625 4.1,0.5 L4.1,1 L10.9,1 L10.9,0.5 C10.9,0.223857625 11.1238576,-1.69088438e-17 11.4,0 L11.6,0 C11.8761424,1.69088438e-17 12.1,0.223857625 12.1,0.5 L12.1,1 L12.1,1 Z M1.2,13.8 L1.2,6 L13.8,6 L13.8,13.8 L1.2,13.8 L1.2,13.8 Z M1.2,2.2 L1.2,4.8 L13.8,4.8 L13.8,2.2 L12.1,2.2 L12.1,2.5 C12.1,2.77614237 11.8761424,3 11.6,3 L11.4,3 C11.1238576,3 10.9,2.77614237 10.9,2.5 L10.9,2.2 L4.1,2.2 L4.1,2.5 C4.1,2.77614237 3.87614237,3 3.6,3 L3.4,3 C3.12385763,3 2.9,2.77614237 2.9,2.5 L2.9,2.2 L1.2,2.2 L1.2,2.2 Z"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

CalendarIcon.displayName = 'CalendarIcon'
